import React from "react";
import { AuthForm } from "@/components/AuthForm";

export default function SignIn() {
  return <AuthForm mode="sign-in" />;
}
